import useAxios from "axios-hooks";
import { BusinessResDto, UsersResDto } from "../../api/Api";
import { useLocation, useParams } from "react-router-dom";
import { BusinessForm } from "./form/BusinessForm";
import { PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { UserQuantityCounter } from "../account/AccountSubscription";
import { BusinessSubscriptionForm } from "./form/BusinessSubscriptionForm";
import moment from "moment";

export default function BusinessSettings() {
  const location = useLocation();
  const params = useParams();

  const [{ data, loading, error }, getMembers] = useAxios<BusinessResDto>(
    `/businesses/${params.businessId}`
  );

  const [{ data: users, loading: usersLoading, error: usersError }, getUsers] = useAxios<UsersResDto>({
    url: `/businesses/${params.businessId ? params.businessId : "me"}/users`,
    params: {
      roles: ["BUSINESS_MEMBER"],
      page: 1,
      limit: 1,
    },
  });

  if (loading || usersLoading) {
    return <h1>Loading...</h1>;
  }

  return (
    <div>
      <div className="divider divider-start">Subscription</div>

      <div className="card bg-base-200">
        <div className="card-body ">
          <div className="w-full">
            <BusinessSubscription
              subscription={data?.subscription}
              users={users?.totalDocs || 0}
            ></BusinessSubscription>
          </div>
        </div>
      </div>

      <div className="divider divider-start mt-20">Business Info</div>

      <div className="card bg-base-200">
        <div className="card-body flex items-center justify-center">
          <div className="w-1/2">
            <BusinessForm defaultValues={data}></BusinessForm>
          </div>
        </div>
      </div>
    </div>
  );
}

function BusinessSubscription(props: { subscription: any, users: number }) {
  const [subscription, setSubscription] = useState<any>(props.subscription);
  const [isEdit, setIsEdit] = useState(false);

  if (!subscription && !isEdit) {
    return (
      <div className="flex flex-col gap-2 items-center justify-center">
        <div>
          <button onClick={() => setIsEdit(true)} className="btn btn-primary">
            CREATE SUBSCRIPTION
          </button>
        </div>
      </div>
    );
  }

  if (isEdit) {
    return (
      <div className="flex items-center justify-center">
        <div className="card bg-base-200 w-1/2">
          <div className="card-body">
            <div className="ml-auto">
              <button
                onClick={() => setIsEdit(false)}
                className="btn btn-outline  btn-circle btn-sm"
              >
                <XMarkIcon className="h-5"></XMarkIcon>
              </button>
            </div>
            <BusinessSubscriptionForm
              onFinish={(subscription: any) => {
                setSubscription(subscription);
                setIsEdit(false);
              }}
              defaultValues={subscription}
            ></BusinessSubscriptionForm>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card bg-base-200 w-full ">
      <div className="w-full">
        <div className="stats shadow w-full">
          <div className="stat ">
            <div className="stat-title">Status</div>
            <div
              className={`stat-value text-2xl   ${
                subscription.status === "ACTIVE" ? "text-success" : ""
              } ${subscription.status === "INACTIVE" ? "text-error" : ""}`}
            >
              {subscription.status}
            </div>
          </div>
          <div className="stat">
              <div className="stat-title">Seats</div>
              <div className="stat-value  flex text-lg">
                <div className="">Total Paid: {props.subscription?.studentQuantity}</div>
                <div className="divider divider-horizontal"></div>
                <div className="">Used: {props.users}</div>
                <div className="divider divider-horizontal"></div>
                <div className="">Remaining: {props.subscription?.studentQuantity - (props.users || 0)}</div>
              </div>
             
            </div>
          <div className="stat">
            <div className="stat-title">Valid from</div>
            <div className="stat-value text-2xl">
              {moment(subscription?.startDate).format("MMM D, YYYY")}
            </div>
          </div>
          <div className="stat">
            <div className="stat-title">Valid To</div>
            <div className="stat-value text-2xl">
              {moment(subscription?.endDate).format("MMM D, YYYY")}
            </div>
          </div>

          <div className="stat">
            <div className="stat-title">
              {moment(subscription?.startDate).isAfter(moment())
                ? "Starts in:"
                : "Expires in:"}
            </div>
            <div className="stat-value text-2xl">
              {Math.floor(
                moment
                  .duration(
                    moment(
                      moment(subscription?.startDate).isAfter(moment())
                        ? subscription?.startDate
                        : subscription?.endDate
                    ).diff(moment())
                  )
                  .asDays()
              )}{" "}
              Days
            </div>
          </div>

          <div className="stat">
            <div className="stat-title"></div>
            <div className="stat-value flex items-center justify-center ">
              <button
                onClick={() => setIsEdit(true)}
                className="btn  btn-primary btn-sm btn-ghost text-primary"
              >
                Edit <PencilIcon className="h-4"></PencilIcon>
              </button>
            </div>
          </div>
        </div>

        {/* <div className="flex items-center">
          <button
            onClick={() => setIsEdit(true)}
            className="btn ml-auto btn-primary btn-sm btn-ghost text-primary"
          >
            Edit <PencilIcon className="h-4"></PencilIcon>
          </button>
        </div> */}
      </div>
    </div>
  );
}
